"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _taggedTemplateLiteral = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _excluded = ["className", "fieldProps", "mode", "templateProps", "wrapperProps"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importStar(require("react"));

var redux_form_1 = require("redux-form");

var index_1 = require("../../../index");

var validators_1 = require("../../../utils/validators");

var Render_1 = __importDefault(require("./Render"));

var Input_1 = __importDefault(require("./Render/Input"));

var Wrapper_1 = __importDefault(require("./Wrapper"));

var InputGroupSC = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 0px !important;\n"])));
var InputGroupItemSC = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));

var DataField = function DataField(_ref) {
  var className = _ref.className,
      fieldProps = _ref.fieldProps,
      mode = _ref.mode,
      templateProps = _ref.templateProps,
      wrapperProps = _ref.wrapperProps,
      props = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = (0, react_1.useContext)(index_1.FormidableContext),
      sc = _ref2.sc;

  if (mode && 'creation' === mode) {
    return react_1.default.createElement("div", null, props.componentType, " : ", props.name);
  }

  var componentType = props.componentType,
      id = props.id,
      name = props.name,
      required = props.required,
      params = props.params,
      type = props.type;

  var parse = function parse(value) {
    var newValue;

    switch (type) {
      case 'number':
      case 'range':
        {
          newValue = value ? Number(value) : '';
          break;
        }

      default:
        newValue = value;
    }

    return newValue;
  };

  var newId = id || "".concat(params && params.name ? "".concat(params.name, ".") : '').concat(name);

  var validate = function validate() {
    var newValidate = [];

    if (required) {
      newValidate.push(validators_1.isRequired);
    }

    switch (type) {
      case 'date':
        {
          newValidate.push(validators_1.isDate);
          break;
        }

      case 'email':
        {
          newValidate.push(validators_1.isEmail);
          break;
        }

      case 'time':
        {
          newValidate.push(validators_1.isTime);
          break;
        }

      default:
    }

    return newValidate.length > 0 ? newValidate : undefined;
  };

  if ('hidden' === type && 'input' === componentType) {
    return null;
  }

  if ('radio' === type && 'input' === componentType) {
    var options = props.options,
        optionsProps = props.optionsProps;

    if (!options || 0 === options.length) {
      return react_1.default.createElement("div", null, "input : erreur de param\xE8tre : options obligatoire");
    }

    return react_1.default.createElement(Wrapper_1.default, _objectSpread(_objectSpread({}, props), {}, {
      id: newId,
      wrapperProps: wrapperProps
    }), react_1.default.createElement(InputGroupSC, _objectSpread(_objectSpread({
      as: sc && sc.inputGroup
    }, optionsProps), {}, {
      role: "radiogroup"
    }), options.map(function (option) {
      return react_1.default.createElement(InputGroupItemSC, {
        key: option.value,
        as: sc && sc.inputGroupItem
      }, react_1.default.createElement(redux_form_1.Field, _objectSpread(_objectSpread({
        fieldProps: fieldProps,
        templateProps: templateProps
      }, props), {}, {
        className: className,
        component: Input_1.default,
        description: option.label,
        descriptionParams: option.params,
        id: option.id || "".concat(newId, "_").concat(option.value),
        validate: validate(),
        value: option.value
      })));
    })));
  }

  return react_1.default.createElement(Wrapper_1.default, _objectSpread(_objectSpread({}, props), {}, {
    id: newId,
    wrapperProps: wrapperProps
  }), react_1.default.createElement(redux_form_1.Field, _objectSpread(_objectSpread({}, props), {}, {
    className: className,
    component: Render_1.default,
    fieldProps: fieldProps,
    id: newId,
    parse: parse,
    templateProps: templateProps,
    validate: validate()
  })));
};

exports.default = DataField;